import apiProxy from '@/services/apiProxy';

export default {
  // Registration endpoints
  async getRegistrationOptions(username, brand_id) {
    const origin = window.location.origin;
    const hostname = window.location.hostname;
    const rpID = hostname.includes('localhost') ? 'localhost' : hostname;
    return apiProxy.call('WebAuthn Register Options', { username, brand_id, rpID, origin });
  },
  
  async verifyRegistration(username, attestationResponse, brand_id) {
    const origin = window.location.origin;
    const hostname = window.location.hostname;
    const rpID = hostname.includes('localhost') ? 'localhost' : hostname;
    return apiProxy.call('WebAuthn Register Verify', { 
      username, 
      attestationResponse, 
      brand_id, 
      rpID, 
      origin
    });
  },
  
  // Authentication endpoints
  async getAuthenticationOptions(username, brand_id) {
    const origin = window.location.origin;
    const hostname = window.location.hostname;
    const rpID = hostname.includes('localhost') ? 'localhost' : hostname;
    return apiProxy.call('WebAuthn Login Options', { username, brand_id, rpID, origin });
  },
  
  async verifyAuthentication(username, assertionResponse, brand_id) {
    const origin = window.location.origin;
    const hostname = window.location.hostname;
    const rpID = hostname.includes('localhost') ? 'localhost' : hostname;
    return apiProxy.call('WebAuthn Login Verify', { 
      username, 
      assertionResponse, 
      brand_id, 
      rpID, 
      origin
    });
  }
}; 